import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ModalBase } from '@components/modal/modal';

import { TableColumnConfig } from '../table-provider';

@Component({
  templateUrl: './table-columns-management.component.html',
})
export class TableColumnsManagementComponent extends ModalBase implements OnInit {
  columns?: TableColumnConfig[];
  override title = $localize`Zarządzanie kolumnami`;

  ngOnInit(): void {
    this.columns.forEach((c) => this.form.registerControl(c.key, new UntypedFormControl(c.isVisible)));
    this.form.updateValueAndValidity();
  }

  submit = () => {
    Object.entries(this.form.value).forEach(([k, v]: [string, boolean]) => {
      const col = this.columns.find((c) => c.key === k);
      col.isVisible = v;
    });
    this.close(this.columns);
  };

  isFirst(index: number): boolean {
    return index === 0;
  }

  isLast(index: number): boolean {
    return index === this.columns.length - 1;
  }

  moveDown(index: number): void {
    this.moveElement(index, index + 1);
  }

  moveUp(index: number): void {
    this.moveElement(index, index - 1);
  }

  private moveElement(currentPos: number, targetPos: number): void {
    this.form.markAsDirty();
    this.columns.splice(targetPos, 0, this.columns.splice(currentPos, 1)[0]);
  }
}
